module.exports = "/build/web/svg/tickets-white.c11d1025fa3dcb1ef51ffab49dc2dc8d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/tickets-white.svg
// module id = 233
// module chunks = 24